import Image from "components/Elements/Image/Image";
import { Toggle } from "components/Elements/Toggle/Toggle";
import { useCustomController } from "components/Reusable/Form/useCustomController";
import { useContent } from "contexts/contentContext/contentContext";
import { useEffect, useState } from "react";
import config from "config";

interface BusinessProfileFieldI {
  image: string;
  title: string;
  text: string;
}

const EmailPrefenrecesField = (props: BusinessProfileFieldI) => {
  const { fieldControls } = useCustomController(props);
  const { getTextByKey, getHtmlByKey } = useContent();
  const [status, setStatus] = useState(fieldControls.value);

  useEffect(() => {
    fieldControls.onChange(status);
  }, [status]);

  return (
    <div className="email-type-settings">
      <div className="email-type-icon">
        <Image alt={props.title} src={props.image} />
      </div>
      <div className="email-type-description">
        <div className="description-title">{getTextByKey(props.title)}</div>
        <div className="description-text">{getHtmlByKey(props.text)}</div>
      </div>
      <div className="email-type-toggle">
        <Toggle status={status} setStatus={setStatus} />
      </div>
    </div>
  );
};

const emailPreferencesFormFields = {
  NotificationsAlertBeforeDeletion: {
    element: "customelement",
    fieldKey: "NotificationsAlertBeforeDeletion",
    render: (props) => (
      <EmailPrefenrecesField
        {...props}
        image={`${config.api.resource}/assets/images/email-preferences/ic4.png`}
        title={"email-preferences-type-alert-before-deletetion-title"}
        text={"email-preferences-type-alert-before-deletetion-text"}
      />
    ),
  },
  UserReceiveRecipientAlertDelete: {
    element: "customelement",
    fieldKey: "UserReceiveRecipientAlertDelete",
    render: (props) => (
      <EmailPrefenrecesField
        {...props}
        image={`${config.api.resource}/assets/images/email-preferences/ic4.png`}
        title={"email-preferences-type-recipient-alert-before-deletetion-title"}
        text={"email-preferences-type-recipient-alert-before-deletetion-text"}
      />
    ),
  },
  NotificationsMarketing: {
    element: "customelement",
    fieldKey: "NotificationsMarketing",
    render: (props) => (
      <EmailPrefenrecesField
        {...props}
        image={`${config.api.resource}/assets/images/email-preferences/ic1.png`}
        title={"email-preferences-type-embed-news-and-updates-title"}
        text={"email-preferences-type-embed-news-and-updates-text"}
      />
    ),
  },
  NotificationsDownloadLink: {
    element: "customelement",
    fieldKey: "NotificationsDownloadLink",
    render: (props) => (
      <EmailPrefenrecesField
        {...props}
        image={`${config.api.resource}/assets/images/email-preferences/ic5.png`}
        title={"email-preferences-type-download-link-title"}
        text={"email-preferences-type-download-link-text"}
      />
    ),
  },
};

export default emailPreferencesFormFields;
